import Vue from "vue";
import VueProgressBar from "vue-progressbar";
import VueFormulate from "@braid/vue-formulate";
import VueScrollTo from "vue-scrollto";
import VueToast from "vue-toast-notification";

import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./icons";

import "./scss/style.scss";
import "vue-toast-notification/dist/theme-sugar.css";

Vue.use(VueProgressBar, {
  color: "#21B1FC",
  failedColor: "red",
  height: "2px"
});
Vue.use(VueFormulate, {
  validationNameStrategy: ["validationName", "label", "name", "type"]
});
Vue.use(VueScrollTo);
Vue.use(VueToast, {
  position: "top-right",
  duration: 5000
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
